<template>
  <b-modal
    v-model="showModal"
    centered
    hide-header
    hide-footer
    modal-class="activity-modal"
    @hidden="onClose"
  >
    <div class="activity-content">
      <div class="tw-h-20 tw-hidden md:tw-block"></div>
      <div class="activity-top tw-w-full tw-px-9 tw-pb-10">
        <div class="tw-flex tw-items-center tw-gap-2">
          <p
            class="tw-text-2xl tw-font-semibold tw-mb-0"
            style="color: #00257d"
          >
            {{ $t("公司活动火热报名中") }}
          </p>
          <img :src="newIcon" alt="" class="tw-w-10" />
        </div>
        <div class="tw-text-primary tw-text-sm tw-mt-2">
          <span>{{ $t("线上会议，全球同步，已有") }}</span>
          <span>{{ item?.registrationCount }}</span>
          <span>{{ $t("位报名") }}</span>
        </div>
      </div>
      <div
        class="activity-main tw-px-4 tw-flex tw-flex-col tw-justify-center tw-items-center tw-gap-3"
      >
        <span
          class="tw-text-textMain tw-text-center tw-font-semibold tw-text-lg"
          >{{ item?.name }}</span
        >

        <div class="tw-flex tw-items-center tw-gap-3">
          <img
            :src="item?.organizerAvatar || avarIcon"
            alt=""
            class="tw-w-10 tw-h-10"
          />
          <span class="tw-text-textMain tw-font-semibold">{{
            item?.organizerName || "天晟科技-Cyrus"
          }}</span>
          <span class="tw-text-textDisabled tw-ml-3">{{
            item?.organizerContact || "tiansheng8161122"
          }}</span>
        </div>
        <div
          class="tw-flex tw-items-center tw-font-semibold tw-text-textMain tw-gap-5"
        >
          <span> {{ formattedDateTime?.date }}</span>
          <span>{{ formattedDateTime?.time }}</span>
        </div>
        <div class="tw-text-primary tw-flex tw-items-center tw-gap-2">
          <span>{{ $t("报名截止时间仅剩") }}</span>
          <span
            class="tw-font-semibold"
            style="
              color: linear-gradient(360deg, #4077f8 0%, #3d4bdf 100%);
              font-size: 32px;
            "
            >{{ remainingDays }}</span
          >
          <span>{{ $t("天") }}</span>
        </div>
      </div>
      <div class="tw-flex tw-justify-center tw-items-center tw-gap-5 tw-py-7">
        <div
          class="tw-py-2.5 tw-px-10 tw-border tw-rounded-xl tw-cursor-pointer tw-text-textLight"
          @click="onClose"
        >
          {{ $t("稍后提醒") }}
        </div>
        <div
          class="activity-but tw-text-white tw-py-2.5 tw-px-10 tw-border tw-rounded-xl tw-cursor-pointer"
          @click="handleConfirm"
        >
          {{ $t("立即报名") }}
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import newIcon from "@/assets/activityMeet/new-icon.png";
import avarIcon from "@/assets/activityMeet/avar.png";
import dayjs from "dayjs";
import duration from "dayjs/plugin/duration";
import "dayjs/locale/zh-cn"; // 导入中文语言包
// 设置 dayjs 使用中文和 duration 插件
dayjs.extend(duration);
dayjs.locale("zh-cn");

export default {
  name: "activityModal",
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    item: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      avarIcon,
      newIcon,
      showModal: false,
    };
  },
  computed: {
    formattedDateTime() {
      if (!this.item?.startTime || !this.item?.endTime) {
        return;
      }

      const startDate = dayjs(this.item.startTime);
      const endDate = dayjs(this.item.endTime);

      // 格式化日期 - 月日星期
      const weekdays = [
        "星期日",
        "星期一",
        "星期二",
        "星期三",
        "星期四",
        "星期五",
        "星期六",
      ];
      const month = startDate.format("M");
      const day = startDate.format("D");
      const weekday = weekdays[startDate.day()];
      const formattedDate = `${month}月${day}日${weekday}`;

      // 格式化时间
      const startTime = startDate.format("HH:mm");
      const endTime = endDate.format("HH:mm");
      const formattedTime = `${startTime}-${endTime} `;

      return {
        date: formattedDate,
        time: formattedTime,
      };
    },
    // 计算剩余报名天数，以活动开始时间为截止时间
    remainingDays() {
      if (!this.item?.startTime) {
        return 0;
      }

      // 假设报名截止时间是活动开始时间，可以根据实际需求调整
      const registrationDeadline = dayjs(this.item.startTime);
      const now = dayjs();
      const diffDays = registrationDeadline.diff(now, "day");

      // 如果已过期则返回0
      return Math.max(0, diffDays);
    },
  },
  watch: {
    show: {
      handler(val) {
        this.showModal = val;
      },
      immediate: true,
    },
  },
  methods: {
    // 立即报名
    async handleConfirm() {
      this.$router.push(`/activity-detail/${this.item.id}`);
      this.showModal = false;
      this.$emit("close");
    },
    // 稍后提醒
    onClose() {
      this.$emit("close");
    },
  },
};
</script>

<style lang="scss" scoped>
.activity-content {
  min-height: 468px;
  position: relative;
  background: url("@/assets/activityMeet/push-bg.png") no-repeat center center;
  background-size: 100% 468px;
}
.activity-but {
  background: linear-gradient(90deg, #4077f8 0%, #3d4bdf 100%);
}

::v-deep .activity-modal {
  .modal-content {
    border: none;
    border-radius: 16px;
    overflow: hidden;
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
    background-color: transparent;
  }

  .modal-body {
    padding: 0;
  }
}

@media (max-width: 768px) {
  .activity-content {
    background: transparent;
  }
  ::v-deep .activity-modal {
    .modal-content {
      background-color: #fff;
    }
  }
  .activity-top {
    padding-top: 20px;
    background: linear-gradient(180deg, #ebf4ff 0%, #ebf4ff 30%, #ffffff 100%);
  }
}
</style>
